import { render, staticRenderFns } from "./FeesImportationErrorsTable.vue?vue&type=template&id=b490cae4&scoped=true"
import script from "./FeesImportationErrorsTable.vue?vue&type=script&lang=js"
export * from "./FeesImportationErrorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b490cae4",
  null
  
)

export default component.exports